import React, { Component } from "react";
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaBuilding } from "react-icons/fa";
// import data from "../../data/mainData.json";
import data from "../../src/data/mainData.json"

class ContactCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      companyName: "Cheran Properties",
      address: "Vanjipalyam, Tirupur, Tamil Nadu",
      phone: "+91 98765 43210",
      email: "info@cheranproperties.com",
      message: "We provide comfortable and affordable housing solutions."
    };
  }

  render() {
    const { companyName, address, phone, email, message } = this.state;
    const { noBg = false } = this.props;

    const cardStyle = {
      backgroundColor: noBg ? "transparent" : "#fff",
      padding: "25px",
      borderRadius: "12px",
      boxShadow: "0 10px 25px rgba(0,0,0,0.15)",
      maxWidth: "450px",
      margin: "40px auto",
      transition: "all 0.3s ease",
      cursor: "pointer",
    };

    const cardHoverStyle = {
      transform: "translateY(-10px)",
      boxShadow: "0 20px 40px rgba(0,0,0,0.2)"
    };

    const labelStyle = {
      fontWeight: "700",
      color: noBg ? "#fff" : "#222",
      marginBottom: "5px",
      display: "flex",
      alignItems: "center",
      gap: "8px"
    };

    const valueStyle = {
      color: noBg ? "#f0f0f0" : "#555",
      marginBottom: "15px",
      fontSize: "15px"
    };

    return (
      <div
        className="contact-card"
        style={cardStyle}
        onMouseEnter={e => Object.assign(e.currentTarget.style, cardHoverStyle)}
        onMouseLeave={e => Object.assign(e.currentTarget.style, { transform: "translateY(0)", boxShadow: "0 10px 25px rgba(0,0,0,0.15)" })}
      >
        <div style={{ textAlign: "center", marginBottom: "20px" }}>
          <img
            src={data?.header?.logo?.img}
            alt="Logo"
            className="img-fluid"
            />
        </div>

        <div>
          <div style={labelStyle}>
            <FaMapMarkerAlt color="#2DBB62" /> Address:
          </div>
          <div style={valueStyle}>{data?.contact?.address_1}</div>

          <div style={labelStyle}>
            <FaPhoneAlt color="#2DBB62" /> Phone:
          </div>
          <div style={valueStyle}>{data?.contact?.phone_1}</div>

          <div style={labelStyle}>
            <FaEnvelope color="#2DBB62" /> Email:
          </div>
          <div style={valueStyle}>{data?.contact?.email}</div>

          {/* <div style={labelStyle}>
            <FaBuilding color="#2DBB62" /> About:
          </div>
          <div style={valueStyle}>{message}</div> */}
        </div>
      </div>
    );
  }
}

export default ContactCard;
